import type { Locale } from "../Locale.js";

export function getJoinWholesaleAnchor(locale: Locale): string {
	return { cs: "#stat-se-partnerem", en: "#become-a-partner" }[locale];
}
